import * as React from 'react';

import {useQuery, useApolloClient} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTemplate as GetTemplateQuery,
    GetTemplateVariables as GetTemplateQueryVariables,
    TemplateFragment as Template,
    TemplateStubFragment as TemplateStub,
} from 'nutshell-graphql-types';

import TEMPLATE_STUB_FRAGMENT from '../../editions/graphql/fragments/template-stub-fragment.graphql';

import GET_TEMPLATE from './graphql/queries/get-template.graphql';

type Props = {
    templateId: string;
    children: (arg1: {
        template: Template | null | undefined;
        templateStub: TemplateStub | null | undefined;
        isLoading: boolean;
        error: string | null | undefined;
    }) => React.ReactElement;
};

export function TemplateQuery(props: Props) {
    const client = useApolloClient();
    let templateStub: TemplateStub | null | undefined;

    try {
        templateStub = client.readFragment({
            id: props.templateId,
            fragmentName: 'TemplateStubFragment',
            fragment: TEMPLATE_STUB_FRAGMENT,
        });
    } catch {
        // Empty
    }

    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetTemplateQuery, GetTemplateQueryVariables>(GET_TEMPLATE, {
        variables: {templateId: props.templateId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    const template = data ? data.template : null;

    return props.children({
        template,
        templateStub,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    });
}
